// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import SavedReplyConstants from 'constants/SavedReplyConstants'

const SavedReplyActions = Marty.createActionCreators({
  updateReply(replyId, reply, notify) {
    return this.app.queries.SavedReplyQueries.updateReply(replyId, reply, notify)
  },

  createReply(reply) {
    return this.app.queries.SavedReplyQueries.createReply(reply)
  },

  deleteReply(replyId) {
    return this.app.queries.SavedReplyQueries.updateReply(replyId, { status: 'ARCHIVED' }, true)
  },

  setReplyToPopulate(replyId) {
    return this.dispatch(SavedReplyConstants.SET_REPLY_TO_POPULATE, replyId)
  }
})

export default SavedReplyActions



// WEBPACK FOOTER //
// ./src/scripts/actions/SavedReplyActions.js